import * as React from 'react';

import { useComboBoxStore } from '../../combobox';
import { Combobox } from '../../combobox-ui';
import { SLASH_KEY } from '../defaults';
import { useSlashOnSelectItem } from '../hooks/useSlashOnSelectItem';
import { SlashComboboxItem } from './SlashComboboxItem';
import { SlashRoot } from './SlashRoot';

export const SlashComboBoxComponent = (): JSX.Element => {
  const onSelectItem = useSlashOnSelectItem();

  return (
    <Combobox
      onSelectItem={onSelectItem}
      onRenderItem={SlashComboboxItem as any}
      RootWrapper={SlashRoot as any}
    />
  );
};

export const SlashComboBox = (): JSX.Element => {
  const key = useComboBoxStore((state) => state.key);

  return (
    <div className={key !== SLASH_KEY ? 'hidden' : ''}>
      <SlashComboBoxComponent />
    </div>
  );
};
